import React from "react";
import "./style.css";

const Footer = () => (
    <footer className="footer">
        © 2020 Kacper Szemraj
    </footer>
);

export default Footer;